(() => {
  if (customElements.get('hola-bundle-builder')) return;

  class HolaBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.engine = this.querySelector('[data-bundle-engine]');
      this.choices = this.querySelector('[data-bundle-choices]');
      this.summary = this.querySelector('[data-bundle-summary]');
      this.review = this.querySelector('[data-bundle-review]');
      this.controls = this.querySelector('[data-bundle-controls]');
      this.status = this.querySelector('[data-bundle-status]');
      this.slotsRoot = this.querySelector('[data-bundle-slots]');
      this.template = this.querySelector('[data-bundle-slot-template]');
      this.footnote = this.querySelector('[data-bundle-footnote]');
      this.loading = this.querySelector('[data-bundle-loading]');
      this.slots = [];
      this.purchasePreference = { selected: [{ value: 'one_time', name: '' }], selects: [] };
      this.ready = false;
      this.deadline = 0;
      this.error = this.querySelector('[data-bundle-error]');
      this.retry = this.querySelector('[data-bundle-retry]');
      this.onRetry = () => {
        if (!this.failed) return;
        this.failed = false;
        this.purchaseRestores = [];
        this.recoveryAttempts = 0;
        this.deadline = Date.now() + 20000;
        this.error.hidden = true;
        this.loading.hidden = false;
        this.dataset.state = 'loading';
        this.refresh();
      };
      this.retry.addEventListener('click', this.onRetry);
      this.syncing = false;
      this.failed = false;
      this.bound = false;
      try {
        this.products = JSON.parse(this.querySelector('[data-bundle-catalog]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-bundle-labels]').textContent);
        if (!this.products.length) return this.fallback();
        this.products.forEach(product => {
          product.id = String(product.id);
          product.variants.forEach(variant => { variant.id = String(variant.id); });
        });
      } catch {
        return this.fallback();
      }
      this.onClick = event => {
        const button = event.target.closest('[data-bundle-count]');
        if (!button || !this.choices.contains(button) || this.syncing || !this.bound) return;
        const count = Number(button.dataset.bundleCount);
        if (count !== 2 && count !== 3) return;
        if (count === this.slots.length) return;
        const next = this.slots.slice(0, count).map(slot => ({ ...slot }));
        while (next.length < count) next.push({ ...next[0] });
        this.apply(next);
      };
      this.onChange = event => {
        const field = event.target;
        const row = field.closest('[data-slot-index]');
        if (!row || !this.choices.contains(row) || this.syncing || !this.bound) return;
        const index = Number(row.dataset.slotIndex);
        const next = this.slots.map(slot => ({ ...slot }));
        const previous = this.variant(next[index].variantId);
        if (field.matches('[data-slot-coffee]')) {
          const product = this.products.find(item => item.id === field.value);
          const options = product ? this.availableVariants(product) : [];
          const variant = options.find(item => item.name === previous?.variant.name) || options[0];
          if (!variant) return this.render();
          next[index] = { productId: product.id, variantId: variant.id };
        } else if (field.matches('[data-slot-grind]')) {
          const match = this.variant(field.value);
          if (!match || match.product.id !== next[index].productId || !this.variantAvailable(match.product, match.variant)) return this.render();
          next[index].variantId = match.variant.id;
        } else {
          return;
        }
        this.apply(next);
      };
      this.choices.addEventListener('click', this.onClick);
      this.choices.addEventListener('change', this.onChange);
      this.onNativeCheckout = event => {
        const button = event.target.closest('.bndlr-add-bundle-to-cart');
        if (!button) return;
        this.labelCheckout();
        if (!this.ready || this.failed || this.syncing || !this.canBind() || !this.nativeTotalReady() || !this.matches(this.slots) || !this.purchaseMatches(this.purchasePreference)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.failed) { this.lock(); this.refresh(); }
        }
      };
      this.engine.addEventListener('click', this.onNativeCheckout, true);
      this.engine.addEventListener('keydown', this.onNativeCheckout, true);
      this.onPurchaseChoice = event => {
        if (!event.isTrusted || this.syncing || this.failed) return;
        const root = this.purchaseControl();
        if (!root || !root.contains(event.target)) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        const current = this.capturePurchase(root);
        if (!current) return;
        const option = event.target.closest('.sls-option-container');
        const radio = event.target.matches('input[type="radio"]') ? event.target : option?.querySelector('input[type="radio"]');
        if (event.target.matches('select')) {
          if (event.type !== 'change' || this.purchasePreference.selected[0]?.value === 'one_time') return;
        } else if (radio && !radio.disabled) {
          current.selected = [{ value: radio.value, name: '' }];
        } else {
          return;
        }
        this.purchasePreference = current;
        this.purchaseFocus = event.target.matches('select') ? { type: 'select', name: event.target.name } : { type: 'radio', value: current.selected[0].value };
        this.purchaseRestores = [];
        this.lock();
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 0);
      };
      this.engine.addEventListener('click', this.onPurchaseChoice, true);
      this.engine.addEventListener('change', this.onPurchaseChoice, true);
      this.engine.addEventListener('keydown', this.onPurchaseChoice, true);
      this.observer = new MutationObserver(() => {
        if (this.syncing || this.failed) return;
        if (!this.canBind() || !this.nativeTotalReady() || !this.matches(this.slots) || !this.purchaseMatches(this.purchasePreference)) this.lock();
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 40);
      });
      this.observer.observe(this.engine, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-variant-id', 'product-quantity', 'data-product-id', 'data-available', 'data-product-handles', 'checked', 'aria-checked', 'class', 'value'] });
      this.pollTimer = setInterval(() => this.refresh(), 250);
      this.refresh();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.refreshTimer);
      clearInterval(this.pollTimer);
      this.retry?.removeEventListener('click', this.onRetry);
      this.choices?.removeEventListener('click', this.onClick);
      this.choices?.removeEventListener('change', this.onChange);
      this.engine?.removeEventListener('click', this.onNativeCheckout, true);
      this.engine?.removeEventListener('keydown', this.onNativeCheckout, true);
      this.engine?.removeEventListener('click', this.onPurchaseChoice, true);
      this.engine?.removeEventListener('change', this.onPurchaseChoice, true);
      this.engine?.removeEventListener('keydown', this.onPurchaseChoice, true);
      this.started = false;
    }

    nativeProduct(productId) {
      return this.engine.querySelector(`.bndlr-mnm-available-products > .bndlr-product[data-product-id="${productId}"]`);
    }

    variant(variantId) {
      for (const product of this.products) {
        const variant = product.variants.find(item => item.id === String(variantId));
        if (variant) return { product, variant };
      }
      return null;
    }

    variantAvailable(product, variant) {
      const native = this.nativeProduct(product.id);
      const option = native?.querySelector(`.bndlr-select-variant option[value="${variant.id}"]`);
      return Boolean(variant.available && native && native.dataset.available !== 'false' && option && !option.disabled);
    }

    availableVariants(product) {
      return product.variants.filter(variant => this.variantAvailable(product, variant));
    }

    canBind() {
      const widgets = this.engine.querySelectorAll('.bndlr-container.bndlr-mixnmatch');
      if (widgets.length !== 1) return false;
      if (!this.engine.querySelector('.bndlr-mnm-selected-products') || !this.engine.querySelector('.bndlr-add-bundle-to-cart')) return false;
      return this.products.every(product => {
        const native = this.nativeProduct(product.id);
        return native?.querySelector('.bndlr-select-variant') && native.querySelector('.quantity-input') && native.querySelector('.bndlr-add-to-bundle');
      }) && this.products.some(product => this.availableVariants(product).length);
    }

    selected() {
      return Array.from(this.engine.querySelectorAll('.bndlr-mnm-selected-products > .bndlr-product[data-variant-id]')).map(row => {
        const quantityNode = row.querySelector('.bndlr-product-quantity');
        const raw = quantityNode?.getAttribute('product-quantity') ?? row.getAttribute('data-quantity');
        const quantity = Number(raw);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 3) throw new Error('Unsupported bundle quantity');
        return { row, variantId: String(row.dataset.variantId), quantity };
      });
    }

    counts(rows = this.selected()) {
      const counts = new Map();
      rows.forEach(row => counts.set(row.variantId, (counts.get(row.variantId) || 0) + row.quantity));
      return counts;
    }

    fingerprint() {
      return JSON.stringify(Array.from(this.counts()).sort(([a], [b]) => a.localeCompare(b)));
    }

    targetCounts(slots) {
      const counts = new Map();
      slots.forEach(slot => counts.set(slot.variantId, (counts.get(slot.variantId) || 0) + 1));
      return counts;
    }

    matches(slots) {
      try {
        const current = this.counts();
        const target = this.targetCounts(slots);
        return current.size === target.size && Array.from(target).every(([id, quantity]) => current.get(id) === quantity);
      } catch {
        return false;
      }
    }

    readSlots() {
      const slots = [];
      for (const row of this.selected()) {
        const match = this.variant(row.variantId);
        if (!match || !this.variantAvailable(match.product, match.variant)) throw new Error('Unsupported bundle variant');
        for (let index = 0; index < row.quantity; index += 1) slots.push({ productId: match.product.id, variantId: row.variantId });
      }
      return slots;
    }

    refresh() {
      if (!this.isConnected || this.syncing || this.failed) return;
      try {
        if (!this.canBind()) {
          this.lock();
          if (this.deadline && Date.now() > this.deadline) this.fallback();
          return;
        }
        this.labelCheckout();
        if (!this.bound) {
          const existing = this.readSlots();
          if (existing.length > 3) return this.fallback();
          this.bound = true;
          if (existing.length === 2 || existing.length === 3) {
            this.apply(existing);
          } else {
            const firstProduct = this.products.find(product => product.id === this.dataset.defaultProduct && this.availableVariants(product).length) || this.products.find(product => this.availableVariants(product).length);
            const secondProduct = this.products.find(product => product.id !== firstProduct.id && this.availableVariants(product).length) || firstProduct;
            const first = existing[0] || { productId: firstProduct.id, variantId: this.availableVariants(firstProduct)[0].id };
            this.apply([first, { productId: secondProduct.id, variantId: this.availableVariants(secondProduct)[0].id }]);
          }
          return;
        }
        if (!this.nativeTotalReady() || !this.matches(this.slots) || !this.purchaseMatches(this.purchasePreference) || !this.ready) {
          const now = Date.now();
          this.purchaseRestores = (this.purchaseRestores || []).filter(time => now - time < 10000);
          if (this.purchaseRestores.length >= 6) return this.fallback();
          this.purchaseRestores.push(now);
          this.apply(this.slots);
        } else {
          this.showPurchaseControl();
        }
      } catch {
        this.fallback();
      }
    }

    expectedNativeTotal() {
      if (this.slots.length !== 2 && this.slots.length !== 3) return null;
      const purchase = this.purchasePreference;
      const oneTime = purchase?.selected[0]?.value === 'one_time';
      const planId = purchase?.selects[0]?.value;
      let total = 0;
      for (const slot of this.slots) {
        const match = this.variant(slot.variantId);
        if (!match) return null;
        const price = oneTime ? match.variant.price : match.variant.sellingPlans?.find(plan => String(plan.id) === planId)?.price;
        if (!Number.isInteger(price) || price < 1) return null;
        total += price;
      }
      return total;
    }

    nativeTotalReady() {
      const button = this.engine.querySelector('.bndlr-add-bundle-to-cart');
      const price = this.engine.querySelector('.bndlr-mnm-total-price .bndlr-new-price');
      const original = this.engine.querySelector('.bndlr-mnm-total-price .bndlr-old-price');
      const expected = this.expectedNativeTotal();
      const oneTime = this.purchasePreference?.selected[0]?.value === 'one_time';
      return expected !== null && button?.dataset.active === 'true' && Number(original?.dataset.currentprice) === expected && (oneTime ? Number(price?.dataset.currentprice) > 0 : Boolean(this.subscriptionTotalSnapshot()));
    }

    subscriptionTotalSnapshot() {
      if (this.purchasePreference?.selected[0]?.value === 'one_time') return null;
      const expected = this.expectedNativeTotal();
      const original = this.engine.querySelector('.bndlr-mnm-total-price .bndlr-old-price');
      if (expected === null || Number(original?.dataset.currentprice) !== expected || !this.matches(this.slots) || !this.purchaseMatches(this.purchasePreference)) return null;
      const text = Array.from(original.childNodes).filter(node => node.nodeType === 3).map(node => node.textContent).join('').trim();
      return text ? { amount: expected, text } : null;
    }

    syncSubscriptionTotal(total) {
      const snapshot = this.subscriptionTotalSnapshot();
      let display = total.querySelector('.hola-bundle-plan-total');
      if (snapshot) {
        if (!display) {
          display = document.createElement('span');
          display.className = 'hola-bundle-plan-total';
          total.appendChild(display);
        }
        if (display.textContent !== snapshot.text) display.textContent = snapshot.text;
        if (display.dataset.price !== String(snapshot.amount)) display.dataset.price = String(snapshot.amount);
        if (total.dataset.holaPriceBasis !== 'subscription') total.dataset.holaPriceBasis = 'subscription';
      } else if (total.dataset.holaPriceBasis) {
        delete total.dataset.holaPriceBasis;
      }
    }

    labelCheckout() {
      const button = this.engine.querySelector('.bndlr-add-bundle-to-cart');
      if (button && button.dataset.active === 'true' && !button.children.length) {
        if (button.textContent.trim() !== this.labels.checkout) button.textContent = this.labels.checkout;
        if (button.title !== this.labels.checkout) button.title = this.labels.checkout;
      }
      const total = this.engine.querySelector('.bndlr-mnm-total-price');
      if (!total || !this.labels.estimatedTotal) return;
      const label = Array.from(total.childNodes).find(node => node.nodeType === 3 && /^(?:Estimated )?Total\s*:\s*$/i.test(node.textContent.trim()));
      const text = `${this.labels.estimatedTotal} `;
      if (label && label.textContent !== text) label.textContent = text;
      this.syncSubscriptionTotal(total);
    }

    enhance() {
      this.labelCheckout();
      if (this.loading) this.loading.hidden = true;
      this.dataset.enhanced = 'true';
      this.choices.hidden = false;
      this.review.hidden = false;
      this.footnote.hidden = false;
    }

    lock() {
      this.ready = false;
      this.dataset.state = 'loading';
      this.engine.inert = true;
      if (!this.deadline && (this.bound || this.engine.getBoundingClientRect().top < document.documentElement.clientHeight)) {
        this.deadline = Date.now() + 20000;
      }
    }

    fallback() {
      this.failed = true;
      this.ready = false;
      this.syncing = false;
      this.dataset.state = 'error';
      this.setAttribute('aria-busy', 'false');
      this.engine.inert = true;
      this.summary.inert = false;
      this.controls.disabled = true;
      this.loading.hidden = true;
      this.status.hidden = true;
      this.error.hidden = false;
    }

    setBusy(busy) {
      this.syncing = busy;
      this.setAttribute('aria-busy', String(busy));
      this.controls.disabled = busy;
      this.engine.inert = busy;
      this.status.textContent = busy ? this.labels.updating : '';
      this.status.hidden = !busy;
      if (busy) this.lock();
      else {
        this.ready = true;
        this.dataset.state = 'ready';
        this.deadline = Date.now() + 20000;
        this.error.hidden = true;
        if (this.purchaseFocus) {
          const root = this.purchaseControl();
          const target = this.purchaseFocus.type === 'select' ? Array.from(root?.querySelectorAll('select') || []).find(select => select.name === this.purchaseFocus.name) : Array.from(root?.querySelectorAll('input[type="radio"]') || []).find(radio => radio.value === this.purchaseFocus.value)?.closest('[role="radio"]');
          target?.focus({ preventScroll: true });
          this.purchaseFocus = null;
        } else if (this.slotFocus) {
          this.slotsRoot.querySelector(`[data-slot-index="${this.slotFocus.index}"] ${this.slotFocus.selector}`)?.focus({ preventScroll: true });
        }
        this.slotFocus = null;
      }
    }

    waitFor(condition, timeout = 3500, observeMutations = true) {
      return new Promise((resolve, reject) => {
        const evaluate = () => {
          if (!this.isConnected) return false;
          try { return condition(); } catch { return false; }
        };
        if (evaluate()) return resolve();
        const observer = new MutationObserver(() => {
          if (evaluate()) finish();
        });
        const finish = error => {
          clearTimeout(timer);
          clearInterval(poll);
          observer.disconnect();
          if (error) reject(error); else resolve();
        };
        const timer = setTimeout(() => finish(new Error('Bundle controls did not update')), timeout);
        const poll = setInterval(() => { if (evaluate()) finish(); }, 80);
        if (observeMutations) observer.observe(this.engine, { childList: true, subtree: true, attributes: true });
      });
    }

    setNativeValue(field, value, force = false) {
      if (!force && field.value === String(value)) return;
      field.value = String(value);
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    rowPurchaseRoots() {
      return this.selected().map(({ row }) => row.querySelector('.sealsubs-full'));
    }

    completePurchaseRoot(root) {
      return Boolean(root?.querySelector('input[type="radio"][value="one_time"]') && root.querySelector('input[type="radio"][data-type="subscription"]') && root.querySelector('input[name="selling_plan"]'));
    }

    purchaseControl() {
      const selectedIds = Array.from(this.counts().keys()).sort();
      const aggregates = Array.from(this.engine.querySelectorAll('.sealsubs-target-element-bundle')).filter(root => {
        if (!this.completePurchaseRoot(root)) return false;
        const ids = (root.getAttribute('data-product-handles') || '').split(',').filter(Boolean).map(item => item.slice(item.lastIndexOf(':') + 1)).sort();
        return ids.length === selectedIds.length && ids.every((id, index) => id === selectedIds[index]);
      });
      if (aggregates.length > 1) return null;
      if (aggregates.length === 1) return aggregates[0];
      const rows = this.rowPurchaseRoots();
      return rows.length === 1 && this.completePurchaseRoot(rows[0]) ? rows[0] : null;
    }

    purchaseRoots() {
      const control = this.purchaseControl();
      return control ? [control] : [];
    }

    showPurchaseControl() {
      const control = this.purchaseControl();
      if (!control) return;
      const single = !control.classList.contains('sealsubs-target-element-bundle');
      if (this.dataset.purchaseControl !== (single ? 'single' : 'aggregate')) this.dataset.purchaseControl = single ? 'single' : 'aggregate';
      for (const root of this.engine.querySelectorAll('.hola-bundle-purchase-native')) {
        if (root !== control) root.classList.remove('hola-bundle-purchase-native');
      }
      if (!control.classList.contains('hola-bundle-purchase-native')) control.classList.add('hola-bundle-purchase-native');
    }

    capturePurchase(root = this.purchaseControl()) {
      if (!root) return null;
      const selected = Array.from(root.querySelectorAll('input[type="radio"]')).filter(input => input.checked).map(input => ({ value: input.value, name: '' }));
      const selects = Array.from(root.querySelectorAll('select')).filter(select => !select.disabled).map(select => ({ value: select.value, text: select.selectedOptions[0]?.textContent.trim(), name: select.name }));
      return selected.length === 1 ? { selected, selects } : null;
    }

    rootPurchaseMatches(root, snapshot) {
      const current = this.capturePurchase(root);
      const desired = snapshot?.selected[0]?.value;
      if (!current || !desired || current.selected[0]?.value !== desired) return false;
      const plan = root.querySelector('input[name="selling_plan"]');
      if (!plan) return false;
      if (desired === 'one_time') return !plan.value;
      if (!snapshot.selects.length) return false;
      return snapshot.selects.every((saved, index) => {
        const select = current.selects.find(item => saved.name && item.name === saved.name) || current.selects[index];
        return select && select.value === saved.value && String(plan.value) === saved.value;
      });
    }

    purchaseMatches(snapshot) {
      const roots = this.purchaseRoots();
      return roots.length > 0 && roots.every(root => this.rootPurchaseMatches(root, snapshot));
    }

    async restorePurchase(snapshot) {
      if (!snapshot?.selected[0]) throw new Error('Purchase intent is missing');
      let stableSince = 0;
      let previousControl = null;
      await this.waitFor(() => {
        const roots = this.purchaseRoots();
        if (!roots.length) { stableSince = 0; return false; }
        for (const root of roots) {
          const desired = snapshot.selected[0].value;
          const input = Array.from(root.querySelectorAll('input[type="radio"]')).find(item => item.value === desired);
          if (!input || input.disabled) throw new Error('Purchase option no longer available');
          const plan = root.querySelector('input[name="selling_plan"]');
          if (!input.checked || (desired === 'one_time' && plan.value)) input.click();
          if (desired !== 'one_time') {
            for (let index = 0; index < snapshot.selects.length; index += 1) {
              const saved = snapshot.selects[index];
              const selects = Array.from(root.querySelectorAll('select')).filter(select => !select.disabled);
              const select = selects.find(item => saved.name && item.name === saved.name) || selects[index];
              if (!select || !Array.from(select.options).some(option => option.value === saved.value && !option.disabled)) throw new Error('Delivery frequency no longer available');
              this.setNativeValue(select, saved.value, String(plan.value) !== saved.value);
            }
          }
        }
        const control = this.purchaseControl();
        if (!this.nativeTotalReady() || !this.purchaseMatches(snapshot) || control !== previousControl) {
          previousControl = control;
          stableSince = 0;
          return false;
        }
        stableSince ||= Date.now();
        return Date.now() - stableSince >= 400;
      }, 18000, false);
      this.showPurchaseControl();
    }

    async reconcile(slots) {
      const target = this.targetCounts(slots);
      for (let attempt = 0; attempt < 16; attempt += 1) {
        if (this.matches(slots)) return;
        const rows = this.selected();
        const counts = this.counts(rows);
        const total = rows.reduce((sum, row) => sum + row.quantity, 0);
        const missing = Array.from(target).find(([id, quantity]) => (counts.get(id) || 0) < quantity);
        const excess = rows.find(row => (counts.get(row.variantId) || 0) > (target.get(row.variantId) || 0));
        const before = this.fingerprint();
        if (missing && (total < 3 || !excess)) {
          const match = this.variant(missing[0]);
          if (!match || !this.variantAvailable(match.product, match.variant)) throw new Error('Unavailable variant');
          const product = this.nativeProduct(match.product.id);
          const select = product.querySelector('.bndlr-select-variant');
          const quantity = product.querySelector('.quantity-input');
          const add = product.querySelector('.bndlr-add-to-bundle');
          this.setNativeValue(select, match.variant.id);
          this.setNativeValue(quantity, 1);
          if (select.value !== match.variant.id) throw new Error('Variant could not be selected');
          add.click();
        } else if (excess) {
          const remove = excess.row.querySelector('.bndlr-close');
          if (!remove) throw new Error('Bundle remove control unavailable');
          remove.click();
        } else {
          throw new Error('Bundle cannot be synchronized');
        }
        await this.waitFor(() => this.fingerprint() !== before);
      }
      if (!this.matches(slots)) throw new Error('Bundle synchronization incomplete');
    }

    async apply(slots, initial = false) {
      if (this.syncing || this.failed || (slots.length !== 2 && slots.length !== 3)) return;
      const valid = slots.every(slot => {
        const match = this.variant(slot.variantId);
        return match && match.product.id === slot.productId && this.variantAvailable(match.product, match.variant);
      });
      if (!valid) return this.fallback();
      const purchase = this.purchasePreference || { selected: [{ value: 'one_time', name: '' }], selects: [] };
      const active = document.activeElement;
      const row = active?.closest('[data-slot-index]');
      this.slotFocus = row && this.choices.contains(row) ? { index: row.dataset.slotIndex, selector: active.matches('[data-slot-coffee]') ? '[data-slot-coffee]' : '[data-slot-grind]' } : null;
      this.purchasePreference = purchase;
      this.slots = slots.map(slot => ({ ...slot }));
      this.setBusy(true);
      try {
        this.dataset.phase = 'selection';
        await this.reconcile(slots);
        this.dataset.phase = 'purchase';
        await this.restorePurchase(purchase);
        if (!this.matches(slots) || !this.purchaseMatches(purchase)) throw new Error('Native selection changed');
        this.slots = slots.map(slot => ({ ...slot }));
        this.purchasePreference = purchase;
        this.render();
        this.enhance();
        this.setBusy(false);
        this.recoveryAttempts = 0;
        this.dataset.phase = 'ready';
      } catch {
        this.syncing = false;
        this.lock();
        this.recoveryAttempts = (this.recoveryAttempts || 0) + 1;
        if (this.recoveryAttempts <= 2 && Date.now() < this.deadline) {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 250);
        } else {
          this.fallback();
        }
      }
    }

    render() {
      const active = document.activeElement;
      const focusedRow = active?.closest('[data-slot-index]');
      const focus = focusedRow && this.contains(focusedRow) ? { index: focusedRow.dataset.slotIndex, selector: active.matches('[data-slot-coffee]') ? '[data-slot-coffee]' : '[data-slot-grind]' } : null;
      const fragment = document.createDocumentFragment();
      const summary = document.createDocumentFragment();
      this.slots.forEach((slot, index) => {
        const match = this.variant(slot.variantId);
        if (!match) return;
        const row = this.template.content.firstElementChild.cloneNode(true);
        row.dataset.slotIndex = String(index);
        row.querySelector('[data-slot-label]').textContent = this.labels.slot.replace('[count]', String(index + 1));
        const image = row.querySelector('[data-slot-image]');
        image.hidden = !match.product.image;
        if (match.product.image) image.src = match.product.image;
        image.alt = `${match.product.name} ${this.labels.bag}`;
        const coffee = row.querySelector('[data-slot-coffee]');
        this.products.forEach(product => {
          const option = new Option(product.name, product.id, false, product.id === slot.productId);
          option.disabled = !this.availableVariants(product).length;
          if (option.disabled) option.textContent += ` · ${this.labels.unavailable}`;
          coffee.add(option);
        });
        const grind = row.querySelector('[data-slot-grind]');
        match.product.variants.forEach(variant => {
          const option = new Option(variant.name, variant.id, false, variant.id === slot.variantId);
          option.disabled = !this.variantAvailable(match.product, variant);
          if (option.disabled) option.textContent += ` · ${this.labels.unavailable}`;
          grind.add(option);
        });
        row.querySelector('[data-slot-facts]').textContent = match.product.roast;
        row.querySelector('[data-slot-notes]').textContent = match.product.notes;
        fragment.append(row);
        const item = document.createElement('li');
        item.textContent = `${match.product.name} · ${this.labels.bag} · ${match.variant.name}`;
        summary.append(item);
      });
      this.slotsRoot.replaceChildren(fragment);
      this.querySelector('[data-bundle-summary-list]').replaceChildren(summary);
      this.querySelector('[data-bundle-summary-heading]').textContent = this.labels.summary.replace('[count]', String(this.slots.length));
      this.querySelectorAll('[data-bundle-count]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.bundleCount) === this.slots.length)));
      if (focus) this.slotsRoot.querySelector(`[data-slot-index="${focus.index}"] ${focus.selector}`)?.focus({ preventScroll: true });
    }
  }

  customElements.define('hola-bundle-builder', HolaBundleBuilder);
})();
